import { inject } from '@angular/core'
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router'
import { combineLatest, of } from 'rxjs'
import { catchError, map, mergeMap, tap } from 'rxjs/operators'
import { AuthService } from '../services/auth.service'
import { RootStoreState, UserProfileActions } from '../../root-store/root-index'
import { Store } from '@ngrx/store'
import { NavSupportService } from '../../modules/app-menu'
import { Location } from '@angular/common'

export const authGuard = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const authService = inject(AuthService)
  const navSupportService = inject(NavSupportService)
  const router = inject(Router)
  const store$ = inject(Store<RootStoreState.State>)
  const location = inject(Location)
  return combineLatest([authService.enforcePasswdChange$, authService.isLoggedIn$, authService.tokenIsValidated$]).pipe(
    mergeMap(([enforcePwChange, isLoggedIn, tokenValidated]) => {
      if (tokenValidated && isLoggedIn && !enforcePwChange) {
        return of(true)
      }
      if (!isLoggedIn) {
        console.log('user is not logged in. redirect to login: ', state.url)
        navSupportService.setDesiredUrl(state.url, next.params)
        location.replaceState('/login')
        return of(router.parseUrl('/login'))
      }
      if (enforcePwChange) {
        console.log('user must change password', router.parseUrl('/profile'))
        navSupportService.setDesiredUrl(next.url, next.params)
        return of(state.url === '/profile' ? true : router.parseUrl('/profile'))
      }
      return authService.validateToken().pipe(
        tap((response) => {
          if (response.tokenIsValid) {
            console.log('token-validation succeeded.')
            store$.dispatch(UserProfileActions.validateTokenSucceeded({ user: response.loginContext }))
          } else {
            console.log('token is invalid. redirect to login')
            store$.dispatch(UserProfileActions.validateTokenFailed())
            console.log('(lr) navigate to /login.')
            router.navigate(['/login'])
          }
        }),
        map((result) => result.tokenIsValid),
        catchError((err) => {
          console.log('validating token error: ', err)
          router.navigateByUrl('/login')
          return of(false)
        })
      )
    })
  )
}
